import styled from "styled-components";

const Main = styled.main`
  display: flex;
  min-height: 100vh;
`;

export default Main;
